import { Nav } from "@deere/fuel-react";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getUserRole } from "../../utils/utils";
import { ROLES, ROUTE_DM } from "../../constants/constant";
import { useSelector } from "react-redux";
 
const Sidebar = (props) => {
  const history = useHistory();
  const userData = useSelector((state) => state.userState.userData);
  const [click, setClick] = useState(() => {
    if(getUserRole(userData) === ROLES.BP || getUserRole(userData) === ROLES.ADMIN) {
      return "Dealer Details";
    } else {
      return "Product Details";
    }
  });
 
  useEffect(() => {
    if (props.state) {
      setClick("Product Details");
    }
  }, [props.state]);
 
 
  const handleNavigation = (route, handler) => {
    history.push(route);
    if (handler) handler();
  };
 
  const handleClick = (event, itemLabel, handler) => {
    event.preventDefault();
    setClick(itemLabel);
    handleNavigation(ROUTE_DM, handler);
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };
 
  const navigationItemsExt = [
    {
      href: "#",
      label: "Dealer Details",
      selected: click === "DEALER",
      onClick: (event) => handleClick(event, "DEALER", props.handleDealersClick),
    },
    {
      href: "#",
      label: "Product Details",
      selected: click === "PRODUCT",
      onClick: (event) => handleClick(event, "PRODUCT", props.handleProductClick),
    },
  ];
 
  // Check if user can access Direct Debit Dealers
  const canAccessDirectDebitDealers =
    getUserRole(userData) === ROLES.BP ||
    (getUserRole(userData) === ROLES.CCM && userData?.country === "JD");

  const navigationItemsIB = [
    ...(getUserRole(userData) === ROLES.BP || getUserRole(userData) === ROLES.ADMIN ? [{
      href: "#",
      label: "Machine Exceptions",
      selected: click === "MACHINE",
      onClick: (event) => handleClick(event, "MACHINE", props.handleMachineClick),
    }] : []),
    ...(canAccessDirectDebitDealers ? [{
      href: "#",
      label: "Direct Debit Dealers",
      selected: click === "DIRECTDEBITDEALER",
      onClick: (event) => handleClick(event, "DIRECTDEBITDEALER", props.handleDirectDebitDealersClick),
    }] : []),
  ];

  const navigationItemsRoleManagement = [
    {
      href: "#",  
      label: <h1 style={{ marginLeft: -38 ,marginTop: -20 }}>Role Management</h1>,

      selected: click === "roleManagement",
      onClick: (event) => handleClick(event, "roleManagement", props.handleRoleManagementClick),
    }
  ];

     
  const navigationItems = [
    {
      label: "Extension Application",
      subNavigationItems:     
        getUserRole(userData) === ROLES.BP || getUserRole(userData) === ROLES.ADMIN
          ? navigationItemsExt
          : navigationItemsExt.slice(0, 1),
    },
    {
      label: "Interest Bearing",
      subNavigationItems: navigationItemsIB,
    },
    {
      // label: "Role Management",      BMD88RQ   
      subNavigationItems: (userData.userID  === "SB04744") && navigationItemsRoleManagement,
   }
  ];
 
  const filteredNavigationItems =
    getUserRole(userData) === ROLES.BP || getUserRole(userData) === ROLES.ADMIN
      ? navigationItems
      : canAccessDirectDebitDealers
      ? navigationItems.slice(0, 2) // CCM with JD country can see Extension Application and Interest Bearing
      : navigationItems.slice(0, 1); // Others see only Extension Application
 
  return (
    <nav style={{ marginTop: "0", backgroundColor: "#fff", width: "304px", padding: "5px", borderRadius: "15px" }}>    
      {filteredNavigationItems.map((item, index) => (
        <Nav style={{ borderBottom: "0px" }} key={index}>
          <div>
            <h3 style={{ marginLeft: "20px"}}>{item.label}</h3>
            <ul style={{ marginLeft: "10px", listStyleType: "none" }}>
              { item.subNavigationItems && item.subNavigationItems.map((subItem, subIndex) => ( 
                <li
                  key={subIndex}
                  onClick={(event) => {
                    subItem.onClick(event);
                    setClick(subItem.label);
                    event.preventDefault();
                    event.target.blur();
                  }}
                  tabIndex="-1"
                  style={{
                    width: "130%",
                    cursor: "pointer",
                    padding: "10px",
                    margin: "5px 0",
                    borderRadius: "5px",
                    backgroundColor: click === subItem.label ? "#F4F8F4" : "white",
                    color: click === subItem.label ? "#367C2B" : "black",
                  }}
                >                
                  {subItem.label}
                </li>
              ))}
            </ul>
          </div>
        </Nav>
      ))}
    </nav>
  );
};
 
export default Sidebar;
